import styled from 'styled-components'

export const Enterprise = styled.div`
  width: 100%;
  padding-right: calc(50% - 440px);
  padding-left: calc(50% - 440px);

  & > * {
    margin: 0 0 24px 0;
  }

  @media (max-width: 832px) {
    padding-right: 16px;
    padding-left: 16px;
  }
`
